export default {
  "t-engagement-management": "Gestión de Actividad",
  "t-engagement-overview": "Resumen de Participación",
  "t-overview": "Resumen",
  "t-device-model": "Modelo de Dispositivo",
  "t-sn-range": "Rango de SN",
  "t-start-number": "N.º inicial",
  "t-end-number": "N.º final",
  "t-complete-sn-range-required": "Ingrese el rango completo de consulta de SN",
  "t-filter": "Filtrar",
  "t-activation-rate": "Tasa de Activación",
  "t-online-rate": "Tasa en Línea",
  "t-usage-rate": "Tasa de Uso",
  "t-high-frequency-activity-rate": "Tasa de Alta Actividad",
  "t-silent-devices": "Dispositivos Silenciosos",
  "t-activated-devices-count": "{count} activados",
  "t-devices-count": "{count} dispositivos",
  "t-device-unit": "dispositivos",
  "t-compared-with-last-week": "vs semana pasada",
  "t-trend": "Tendencia",
  "t-trend-analysis": "Análisis de Tendencias",
  "t-recent-7-days": "Últimos 7 días",
  "t-recent-30-days": "Últimos 30 días",
  "t-recent-7-days-metrics-trend": "Tendencia de métricas de los últimos 7 días",
  "t-recent-30-days-metrics-trend": "Tendencia de métricas de los últimos 30 días",
  "t-total-uptime": "Tiempo Total en Línea",
  "t-total-uptime-list": "Lista de Tiempo Total en Línea de Dispositivos",
  "t-total-uptime-list-desc": "Estadísticas de la duración total de conexión con TMS y la actividad de múltiples señales de cada dispositivo",
  "t-heartbeat-statistics": "Estadísticas de Heartbeat",
  "t-heartbeat": "Estadísticas de Heartbeat",
  "t-heartbeat-statistics-list": "Lista de Estadísticas de Señales Activas de Dispositivos",
  "t-heartbeat-statistics-list-desc": "Detalles de actividad multiseñal por dispositivo (lectura de tarjeta o tráfico; cualquier umbral alcanzado cuenta como activo)",
  "t-heartbeat-signal": "Señal Activa",
  "t-card-swipe-count": "Lecturas de Tarjeta",
  "t-print-count": "Impresiones",
  "t-print-distance": "Distancia de impresion",
  "t-business-traffic": "Tráfico de Negocio",
  "t-screen-on-duration": "Duración de Pantalla Encendida",
  "t-active-time": "Hora de Activación",
  "t-active-time-list": "Lista de Hora de Activación de Dispositivos",
  "t-active-time-list-desc": "Registra el momento en que cada dispositivo completó la activación y se conectó por primera vez",
  "t-days-from-now": "Hace",
  "t-days-ago": "hace {count} días",
  "t-inactive-device-alert": "Alerta de Dispositivo Silencioso",
  "t-inactive-device-alert-list": "Lista de Alertas de Dispositivos Silenciosos",
  "t-inactive-device-alert-list-desc": "Dispositivos que tuvieron señales activas el mes pasado, pero no tienen señales activas este mes y tienen una duración en línea insuficiente",
  "t-idle-device-alert": "Alerta de Dispositivo Inactivo en Línea",
  "t-idle-device-alert-list": "Lista de Alertas de Dispositivos Inactivos en Línea",
  "t-idle-device-alert-list-desc": "Lista de alertas para dispositivos que están en línea pero no tienen señales activas durante el periodo estadístico (OR multiseñal L2: lectura de tarjeta/impresión/tráfico/pantalla encendida)",
  "t-idle-devices-total": "Total de Dispositivos Inactivos en Línea",
  "t-idle-days": "Días Inactivos en Línea",
  "t-pending-activation": "Activación Pendiente",
  "t-pending-activation-list": "Lista de Activación Pendiente",
  "t-pending-activation-list-desc": "Dispositivos ingresados en el sistema TMS pero nunca activados en línea, ordenados por días desde el ingreso (los registros más antiguos requieren más atención)",
  "t-pending-activation-total": "Total de Dispositivos con Activación Pendiente",
  "t-threshold-settings": "Configuración de Umbrales",
  "t-edit-threshold-settings": "Editar Configuración de Umbrales",
  "t-threshold-settings-list": "Lista de Configuración de Umbrales",
  "t-threshold-settings-list-desc": "Gestionar los parámetros de umbral para determinar los niveles de actividad en el sistema",
  "t-threshold-config-name": "Nombre de Configuración",
  "t-threshold-type": "Tipo de Umbral",
  "t-threshold-value": "Umbral",
  "t-threshold-type-online-duration": "Duración en Línea",
  "t-threshold-type-silent-days": "Días Silenciosos",
  "t-threshold-type-idle-detection": "Detección de Inactividad",
  "t-threshold-type-card-swipe-count": "Número de Lecturas de Tarjeta",
  "t-threshold-type-unactivated-days": "Días No Activados",
  "t-threshold-type-screen-on-duration": "Duración de Pantalla Encendida",
  "t-threshold-type-business-traffic": "Tráfico de Negocio",
  "t-online-duration-threshold": "Umbral de Duración en Línea",
  "t-silent-device-threshold": "Umbral de Dispositivo Silencioso",
  "t-idle-device-threshold": "Umbral de Dispositivo Inactivo",
  "t-high-frequency-active-threshold": "Umbral de Alta Actividad",
  "t-unactivated-reminder-threshold": "Umbral de Recordatorio No Activado",
  "t-screen-on-duration-threshold": "Umbral de Pantalla Encendida",
  "t-business-traffic-threshold": "Umbral de Tráfico de Negocio",
  "t-threshold-value-24h": "24 h",
  "t-threshold-value-7-days": "7 días",
  "t-threshold-value-3-days": "3 días",
  "t-threshold-value-50-times-day": "50 veces/día",
  "t-threshold-value-30-days": "30 días",
  "t-threshold-value-2h": "2 h",
  "t-threshold-value-10mb-day": "10 MB/día",
  "t-online-duration-threshold-desc": "Los dispositivos se consideran activos cuando la duración continua en línea supera este umbral",
  "t-silent-device-threshold-desc": "Los dispositivos se consideran silenciosos si no se detecta señal activa después de este número de días",
  "t-idle-device-threshold-desc": "Los dispositivos se consideran inactivos cuando están en línea sin actividad de negocio más allá de este número de días",
  "t-high-frequency-active-threshold-desc": "Los dispositivos se consideran de alta actividad cuando las lecturas diarias de tarjeta superan este umbral",
  "t-unactivated-reminder-threshold-desc": "Se activa un recordatorio cuando los dispositivos siguen sin activarse después de este número de días desde el ingreso",
  "t-screen-on-duration-threshold-desc": "Los dispositivos se cuentan como activos cuando la duración diaria de pantalla encendida supera este umbral",
  "t-business-traffic-threshold-desc": "Los dispositivos se cuentan como activos cuando el tráfico diario de negocio supera este umbral",
  "t-pending-days": "Días desde el Ingreso",
  "t-activation-analytics": "Análisis de Activación",
  "t-activation-analytics-list": "Análisis de Activación por Socio",
  "t-activation-analytics-list-desc": "Resumen del estado de activación de dispositivos de cada socio, con soporte para ordenar por tasa de activación",
  "t-activation-analytics-total": "Total de Análisis de Activación",
  "t-activation-rate-rank": "Tasa de Activación",
  "t-partner-count": "Socios",
  "t-average-activation-rate": "Tasa Media de Activación",
  "t-highest-activation-rate": "Tasa Máxima de Activación",
  "t-lowest-activation-rate": "Tasa Mínima de Activación",
  "t-network-devices": "Dispositivos en Línea",
  "t-activated": "Activados",
  "t-unactivated": "No Activados",
  "t-entry-time": "Hora de Ingreso",
  "t-inventory-estimation": "Estimación de Inventario",
  "t-latest-heartbeat": "Último Heartbeat",
  "t-suspected-in-inventory": "Posible en Inventario",
  "t-long-term-not-powered-on": "Sin encendido durante mucho tiempo",
  "t-contact-partner-for-verification": "Contactar al socio para verificación",
  "t-idle-duration": "Duración Inactiva",
  "t-hour-unit": "h",
  "t-idle-over-72-hours": "Inactivo ≥72 Horas",
  "t-idle-24-72-hours": "Inactivo 24-72 Horas",
  "t-idle-under-24-hours": "Inactivo <24 Horas",
  "t-continuously-online-no-business": "Continuamente en línea sin negocio",
  "t-follow-up-business-opening-status": "Dar seguimiento al estado de apertura del negocio",
  "t-possible-temporary-maintenance": "Posible mantenimiento temporal",
  "t-current-online-status": "Estado en Línea Actual",
  "t-warning-level": "Nivel de Advertencia",
  "t-warning-high": "Alto",
  "t-warning-medium": "Medio",
  "t-warning-low": "Bajo",
  "t-contact-merchant": "Contactar Comercio",
  "t-observe": "Observar",
  "t-last-month-active-signal": "Señal Activa del Mes Pasado",
  "t-this-month-active-signal": "Señal Activa de Este Mes",
  "t-this-month-online-duration": "Duración en Línea de Este Mes",
  "t-total-online": "Total en Línea",
  "t-last-active": "Última Hora en Línea",
  "t-total-devices-count": "Total {count} dispositivos",
  "t-silent-devices-total": "Total de Dispositivos Silenciosos",
  "t-risk-critical-days": "Crítico (≥30 días)",
  "t-risk-medium-days": "Medio (14-29 días)",
  "t-risk-watch-days": "Observación (7-13 días)",
  "t-suspected-fault-or-permanent-offline": "Posible fallo o desconexión permanente",
  "t-merchant-status-follow-up-needed": "Se requiere seguimiento del estado del comercio",
  "t-continuous-monitoring": "Monitoreo continuo",
  "t-silent-days": "Días Silenciosos",
  "t-day-unit": "días",
  "t-last-card-swipe-time": "Última Lectura de Tarjeta",
  "t-risk-level": "Nivel de Riesgo",
  "t-risk-critical": "Crítico",
  "t-risk-medium": "Medio",
  "t-risk-watch": "Observación",
  "t-follow-up": "Seguimiento",
  "t-view-threshold-settings": "Ver Configuración de Umbrales",
  "t-close": "Cerrar",
  "t-fetch-failed": "Error al obtener datos",
  "t-save-success": "Guardado exitosamente",
  "t-save-failed": "Error al guardar",
  "t-threshold-value-range": "El valor del umbral debe estar entre 1 y 100",
}
